import React from 'react';
import { Form, Radio, DatePicker, Selector, Button, Icon, Upload, InputNumber } from '@roo/roo';
import styled from 'styled-components';
import { requiredRule, getRuleLen } from '../../../../utils/rules';
import { FieldX } from './fieldx';
import { get } from 'lodash';
import { OrgKs, getCert } from '../../_utils/config';
import { useSimpleContext } from '../../_context';
import { FieldView } from '../../_components/FieldView';
import { FilesView } from '../../_components/FilesView';
import {getPopContainer} from "../../../apply/_utils";

const OrgDiv = styled.div`
  .org-type-form {
    margin-top: 24px;
    //display: flex;
    width: 75%;
    margin-left: 25%;
    label {
      text-align: left;
    }
  }
  .cert-list {
    width: calc(100% + 94px);
    background: #fafafa;
    border-radius: 8px;
    padding: 24px;
    margin-left: -95px;
    color: #000;
    label {
      text-align: left;
    }
  }
  .cert-table {
    display: grid;
    grid-template-columns: repeat(4, auto);
    border: 1px solid #eee;
    grid-gap: 1px;
    background-color: #eee;
    //height: 300px;
    div {
      background-color: #fff;
      padding: 0 4px;
    }
    .c-title {
      background: #fafafa;
      text-align: center;
      height: 40px;
      display: inline-block;
      line-height: 40px;
    }
    .c-type {
      height: 40px;
      display: inline-block;
      line-height: 40px;
      text-align: center;
    }
    .c-persist,
    .c-date {
      div {
        display: inline-block;
        height: 40px;
        line-height: 40px;
        text-align: center;
        width: 100%;
      }
    }
    .c-persist,
    .c-date {
      height: 40px;
      div,
      input {
        height: 40px;
      }
    }
    .c-date {
      .addon-icon {
        display: inline-block !important;
        height: 38px;
        line-height: 38px;
      }
    }
    .c-file {
      height: 40px;
      button {
        height: 100%;
      }
      text-align: center;
    }
  }
`;
function useValidateCerts() {
  const { state } = useSimpleContext((t) => [t.disabled, t.hasSubmit]);
  return function validateCerts(certs = []) {
    if (state.disabled || state.isViewType || state.hasSubmit) {
      return undefined;
    }
    for (let i = 0; i < certs.length; i++) {
      const { isLongEffective, invalidDate, fileUrl } = certs[i];
      if (isLongEffective === 0 && !invalidDate) {
        return '请选择到期时间';
      }
      if (!fileUrl) {
        return '请上传证书文件';
      }
    }
    return undefined;
  };
}

export const Organization = function (props) {
  const { values, idx } = props;
  //0-一般企业 1-政府机关 2-个体工商户 3-事业单位 4-社会团体 5-其他机构
  const orgType = get(values, `organizationType`);
  const { state } = useSimpleContext((t) => [t.disabled]);

  return (
    <OrgDiv className={'form-patch'}>
      <FieldView
        required={true}
        label='机构名称'
        name={`baseInfo.${idx}.organizationName`}
        placeholder='请输入主申报机构的全称'
        rule={getRuleLen(20, true)}
        disabled={state.disabled}
      />
      <FieldView
        required={true}
        label='机构类型'
        name={`baseInfo.${idx}.organizationType`}
        data={[
          { id: 0, name: '一般企业' },
          { id: 1, name: '政府机关' },
          { id: 2, name: '个体工商户' },
          { id: 3, name: '事业单位' },
          { id: 4, name: '社会团体' },
          { id: 5, name: '其他机构' },
        ]}
      />
      <FieldX
        className={'org-id'}
        label='统一社会信用代码'
        name={`baseInfo.${idx}.creditCode`}
        placeholder='请输入此机构的统一社会信用代码'
        // display={'row'}
        orgType={orgType}
        show={false}
      />
      <FieldX
        required={true}
        className={'org-id'}
        label='企业资质证书'
        name={`baseInfo.${idx}.certification`}
        layout={'vertical'}
        orgType={orgType}
        rule={undefined}
        show={false}
      >
        <div>
          <div className='t-info'>
            <Icon name='info-circle-o' />
            营业执照，组织机构代码证，税务登记证(请上传证件扫描件或拍摄清晰的数码照)
          </div>
        </div>
      </FieldX>
      <FieldView
        required={false}
        className={'org-id'}
        label='资质证书'
        name={`baseInfo.${idx}`}
        orgType={orgType}
        show={false}
      >
        <OrganizationCert orgType={orgType} />
      </FieldView>
      <FieldX
        label={'成立日期'}
        name={`baseInfo.${idx}.registerDate`}
        placeholder={'请选择'}
        as={
          <DatePicker
            clearable={true}
            format={'YYYY-MM-DD'}
            valueOfType={'string'}
            popupContainer={getPopContainer}
          />
        }
        orgType={orgType}
        show={false}
      />
      <FieldX
        name={`baseInfo.${idx}.${OrgKs.location}`}
        placeholder={'请输入精确到街道的地址'}
        orgType={orgType}
        show={false}
      />
      <FieldX
        name={`baseInfo.${idx}.${OrgKs.legalPerson}`}
        placeholder={'请输入法定代表人姓名'}
        orgType={orgType}
        show={false}
      />
      <FieldX
        name={`baseInfo.${idx}.${OrgKs.registeredCapital}`}
        placeholder={'请输入注册资金(可输入小数点)，若无则填无'}
        orgType={orgType}
        show={false}
      />
    </OrgDiv>
  );
};

// 资质证书
export const OrganizationCert = function (props) {
  const { value } = props;
  const certs = value.qualificationCertificate || [];
  const isMerge = value.isMerge || [];

  return (
    <div className={'cert-list'}>
      <div className={'v-field'} style={{ marginBottom: 12 }}>
        <div className={'v-label'} style={{ textAlign: 'left' }}>
          是否三证合一
        </div>
        <div className={'v-value'}>{isMerge ? '是' : '否'}</div>
      </div>
      <div className={'cert-table'}>
        <div className={'c-title'}>证件类型</div>
        <div className={'c-title'}>是否长期有效</div>
        <div className={'c-title'}>到期日期</div>
        <div className={'c-title'}>上传附件</div>
        {(certs || []).map((cert, certIdx) => {
          return <OrgCertItem cert={cert} {...props} certIdx={certIdx} />;
        })}
      </div>
    </div>
  );
};

function OrgCertItem(props) {
  const { cert } = props;
  const certName = ['三证合一', '营业执照', '组织机构代码证', '税务登记证'];
  const certName2 = ['0', '1', '2', '事业单位法人证书', '社会团体法人登记证书'];

  function getCertName(code) {
    return certName[code] || certName2[Number(props.value.organizationType)];
  }

  return (
    <React.Fragment>
      <div className={'c-type'}>{getCertName(Number(cert.type))}</div>
      <div className={'c-persist'}>
        <div>{cert.isLongEffective ? '是' : '否'}</div>
      </div>
      <div className={'c-date'}>
        <div>{cert.invalidDate}</div>
      </div>
      <div className={'c-file'}>
        <FilesView value={cert.fileUrl} style={{ position: 'relative', top: 12 }} />
      </div>
    </React.Fragment>
  );
}
